import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp } from 'styled-tools';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { FlexRow } from 'components/Shared/Scaffolding';
import { CardWrapper } from 'components/Shared/Cards';
import { Icon, GLYPHS } from 'components/Shared/Icon';
import { SCAFFOLDING, SECTIONS, TRANSITION } from 'theme';
import { FirstChild } from 'utils/transitions';

const Style = styled(CardWrapper)`
    overflow: hidden;

    ${ifProp(
        'isSelected',
        css`
            background-color: ${SECTIONS.DARK.BG};
            color: ${SECTIONS.DARK.COLOR};
        `
    )}
`;

const StyleImage = styled.span`
    flex: 0 0 ${SCAFFOLDING.COLUMN_WIDTH(7)};
    display: inline-block;
    height: ${SCAFFOLDING.GUTTER_FACTOR(5)};
    background-color: ${SECTIONS.SUB.BG};
    background-position: center;
    background-repeat: no-repeat;
`;

const StyleDesc = styled.span`
    flex: 1 1 auto;
    display: inline-block;
    position: relative;
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    word-wrap: break-word;
    word-break: break-word;
`;

const StyleName = styled.span`
    display: block;
    font-size: 1.1em;
    font-weight: 700;
`;

const StyleBy = styled.span`
    display: block;
    font-style: italic;
`;

const StyleCheck = styled(Icon)`
    position: absolute;
    left: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    bottom: ${SCAFFOLDING.GUTTER_FACTOR(0.5)};
    color: #fff;
    font-size: 3em;

    &.checked-enter {
        opacity: 0;
    }

    &.checked-enter-active {
        opacity: 1;
        transition: opacity ${TRANSITION.LENGTH_LONG} ${TRANSITION.BEZIER};
    }
`;

const SearchResultPreview = ({ style, isSelected, selectStyle }) => {
    return (
        <Style isSelected={isSelected} type="button" onClick={() => selectStyle(style, isSelected)}>
            <FlexRow spacing={0}>
                <StyleImage style={{ backgroundImage: `url(${style.imageUrl})` }} />
                <StyleDesc>
                    <StyleName>{style.name}</StyleName>
                    <StyleBy>by {style.createdBy}</StyleBy>
                    <CSSTransitionGroup
                        component={FirstChild}
                        transitionName="checked"
                        transitionEnterTimeout={300}
                        transitionLeaveTimeout={300}
                    >
                        {isSelected ? <StyleCheck glyph={GLYPHS.CHECK} /> : null}
                    </CSSTransitionGroup>
                </StyleDesc>
            </FlexRow>
        </Style>
    );
};

export default SearchResultPreview;
